/*
 * sl-display-price.js — studiolab
 *
 * Keeps product.metafields.custom.preco_exibicao in sync with Palo Alto's
 * client-side price updates. Liquid owns the first render; this file only
 * reapplies the same display/compare pair after variant and quantity changes.
 * Cart and checkout remain untouched and continue to use Shopify's real price
 * plus the automatic discount.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-sl-display-price][data-sl-native-price]';

  function money(cents) {
    var withCurrency = window.theme && window.theme.settings && window.theme.settings.currency_code_enable;
    var format = withCurrency ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
    return window.theme && typeof window.theme.formatMoney === 'function'
      ? window.theme.formatMoney(cents, format)
      : (cents / 100).toFixed(2);
  }

  function quantity(wrapper) {
    if (!wrapper.hasAttribute('data-atc-button')) return 1;
    var productInfo = wrapper.closest('product-info');
    var field = productInfo && productInfo.querySelector('[data-quantity-field]');
    var value = field ? parseInt(field.value || '1', 10) : 1;
    return value > 0 ? value : 1;
  }

  function apply(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(SELECTOR).forEach(function (wrapper) {
      var displayPrice = parseInt(wrapper.getAttribute('data-sl-display-price'), 10);
      var nativePrice = parseInt(wrapper.getAttribute('data-sl-native-price'), 10);
      if (isNaN(displayPrice) || displayPrice < 0) return;

      var multiplier = quantity(wrapper);
      var price = wrapper.querySelector('[data-product-price]');
      var compare = wrapper.querySelector('[data-compare-price], .product__price--strike');

      if (price) {
        price.innerHTML = money(displayPrice * multiplier);
        price.classList.toggle('product__price--sale', nativePrice > displayPrice);
      }

      if (compare && nativePrice > displayPrice) {
        compare.innerHTML = money(nativePrice * multiplier);
        compare.classList.remove('hidden');
        compare.style.display = '';
      } else if (compare) {
        compare.classList.add('hidden');
        compare.style.display = 'none';
      }
    });

    scope.querySelectorAll('product-info').forEach(function (productInfo) {
      var marker = productInfo.querySelector(SELECTOR);
      if (!marker) return;
      productInfo.querySelectorAll('[data-form-wrapper]').forEach(function (formWrapper) {
        formWrapper.dataset.variantPrice = marker.getAttribute('data-sl-display-price');
        var displayPrice = parseInt(marker.getAttribute('data-sl-display-price'), 10);
        var nativePrice = parseInt(marker.getAttribute('data-sl-native-price'), 10);
        if (nativePrice > displayPrice) {
          formWrapper.dataset.variantComparePrice = nativePrice.toString();
        } else {
          delete formWrapper.dataset.variantComparePrice;
        }
      });
    });
  }

  function schedule(root) {
    window.setTimeout(function () { apply(root || document); }, 0);
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-quantity-field]')) schedule();
  });
  document.addEventListener('shopify:section:load', function (event) {
    schedule(event.target);
  });

  if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function () { schedule(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(document); });
  } else {
    apply(document);
  }
})();
